import React from "react";
import "./TitleStrengthMeter.scss";

const zoneFor = (count) => {
  if (count === 0) return "empty";
  if (count < 20) return "short";
  if (count > 95) return "long";
  return "ideal";
};

const HINT = {
  ideal: "Clear and specific",
  short: "A bit short - add the buyer's key details",
  long: "Getting long - trim to the essentials",
  empty: "Name what the buyer wants, the area, and a feature",
};

const TitleStrengthMeter = ({ count = 0, max = 100, error = false }) => {
  const zone = zoneFor(count);
  const fill = Math.min(100, (count / max) * 100);
  return (
    <div className={`title-strength-meter zone-${zone} ${error ? "has-error" : ""}`}>
      <div className="tsm-bar">
        <span className="tsm-fill" style={{ width: `${fill}%` }} />
      </div>
      <div className="tsm-meta">
        <span className="tsm-hint">{HINT[zone]}</span>
        <span className="tsm-count">
          {count}/{max}
        </span>
      </div>
    </div>
  );
};

export default TitleStrengthMeter;
